<template>
  <div class="footer">
    <b-row align-v="center" align-h="between" class="mt-3">
      <b-col cols="8" md="5">
        <b-button
          variant="outline-dark"
          :disabled="currentStep == 0"
          @click="$emit('step-clicked', { action: 'prev', step: currentStep })"
        >
          <font-awesome-icon :icon="['far', 'chevron-left']" fixed-width />
          <span class="ml-1">Anterior</span>
        </b-button>
        <b-button
          type="button"
          variant="outline-dark"
          class="ml-2"
          :disabled="currentStep == steps.length - 1"
          @click="$emit('step-clicked', { action: 'next', step: currentStep })"
        >
          <span>Siguiente</span>
          <font-awesome-icon :icon="['far', 'chevron-right']" fixed-width />
        </b-button>
      </b-col>
      <b-col md="2" class="d-none d-md-flex justify-content-center mb-2 ">
        <div class="dots">
          <span
            v-for="step in steps" :key="step.label"
            :class="['dot', { 'dot-active': currentStep === step.step, 'dot-done': currentStep > step.step }]"
            @click="$emit('step-clicked', { action: 'dot-clicked', step: step })"
          ></span>
        </div>
      </b-col>
      <b-col cols="4" md="5" class="d-flex justify-content-end">
        <button
          v-if="currentStep > 0"
          class="submit-button"
          @click="$emit('create-order')"
        >
        <div class="d-flex fs-16 align-items-center">
          <span>Crear</span>
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=" ml-2" style="width: 19px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
          </svg>
        </div>
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Button from '../../../../components/shared/Button'

export default {
  name: "StepFooter",
  components: { Button },
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    steps: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style scoped>
  .dots { display: flex; align-items: center; gap: 6px; }
  .dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #ddd;
    cursor: pointer;
    transition: background 0.2s, transform 0.2s;
  }
  .dot-done   { background:  #29A745;}
  .dot-active { background: #1d58b7; transform: scale(1.3); }
  .submit-button {
    display: inline-block;
    font-weight: 400;
    color: #1d58b7;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: #1d58b7 1px solid;
    background-color: transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out, #1d58b7 .15s ease-in-out, #1d58b7 .15s ease-in-out, #1d58b7 .15s ease-in-out;
  }
  .submit-button:focus,
  .submit-button.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(29, 88, 183, 0.25);
  }
  .submit-button:hover {
    color: #f0f3f6;
    background-color: #1d58b7;
  }
</style>
